import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../Components/Navbar/navbar";
import { useLocation, useNavigate } from "react-router";
import styles from "../Styles/tables.module.css";
import { Url, getUser } from "../../Constants/globals";
import { TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled } from "react-icons/tb";
import axios from "axios";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { HiPencil, HiPlus, HiTrash, HiSearch, HiX, HiCreditCard } from "react-icons/hi";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";

async function deleteCompanyFunction(id){
  try {
    await axios.delete(`${Url}/companies/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Empresa eliminada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteCompanyFunction(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a empresa"}</Alert>];
    }
  };
}

async function getCompanies(page, search){
  try {
    const res = await axios
    .get(`${Url}/companies?page=${page ? page : 1}${search ? "&search="+search : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCompanies(page, search);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function Empresas({userPermissions}) {

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [deleteCompany, setDeleteCompany] = useState("");
  const [alert, setAlert] = useState("");
  const searchRef = useRef(null);
  const [loadingData, setLoadingData] = useState(true);
  const [companiesData, setCompaniesData] = useState([]);
  const [previousPage, setPreviousPage] = useState("");
  const [nextPage, setNextPage] = useState("");
  const [currentPage, setCurrentPage] = useState(state?.page ? state.page : "");
  const [perPage, setPerPage] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");
  const [total, setTotal] = useState(0);

  async function assignData() {
    const thisCompaniesData = await getCompanies(currentPage);
    setCurrentPage(thisCompaniesData.current_page);
    setNextPage(thisCompaniesData.next_page);
    setPreviousPage(thisCompaniesData.prev_page);
    setPerPage(thisCompaniesData.per_page);
    setCompaniesData(thisCompaniesData);
    setTotal(thisCompaniesData.total_companies);
    setLoadingData(false);
  }

  useEffect(() => {
    assignData();
  }, []);

  async function handlePageChange(next, start) {
    if (next) {
      const newCompaniesData = await getCompanies(start ? start : nextPage, nomeSearch);
      setCompaniesData(newCompaniesData);
      setCurrentPage(newCompaniesData.current_page);
      setNextPage(newCompaniesData.next_page);
      setPreviousPage(newCompaniesData.prev_page);
      setPerPage(newCompaniesData.per_page);
      setTotal(newCompaniesData.total_companies);
    }
    else if (!next && previousPage) {
      const newCompaniesData = await getCompanies(previousPage, nomeSearch);
      setCompaniesData(newCompaniesData);
      setCurrentPage(newCompaniesData.current_page);
      setNextPage(newCompaniesData.next_page);
      setPreviousPage(newCompaniesData.prev_page);
      setPerPage(newCompaniesData.per_page);
      setTotal(newCompaniesData.total_companies);
    }
    else {
      return;
    }
  }

  const handleSearchContainer = () => {
    if (showSearch){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShowSearch(false);
        setIsPoppedOut(false);
      },280);
    } else {
      setShowSearch(true);
      setTimeout(() => {
        searchRef.current.focus();
      }, 280);
    }
  }

  async function handleSearch(input) {
    if (input === false){
      setNomeSearch("");
    }
    const searchCompaniesData = await getCompanies(1, input === false ? "" : nomeSearch);
    setCurrentPage(searchCompaniesData.current_page);
    setNextPage(searchCompaniesData.next_page);
    setPreviousPage(searchCompaniesData.prev_page);
    setPerPage(searchCompaniesData.per_page);
    setCompaniesData(searchCompaniesData);
    setTotal(searchCompaniesData.total_companies);
  }

  async function getAlertDelete(id) {
    if (id){
      await setAlert("");
      const res = await deleteCompanyFunction(id);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  function getLastPage(){
    const calc = total / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  return (
    <div className="body">
      {alert}
      {deleteCompany}
      <NavBar current={"empresas"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={styles.btnAdd} onClick={() => navigate("/empresas/adicionar")}>
              <HiPlus size={20}/>
              <p className={styles.textAdd}>Adicionar</p>
            </button>
            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
            {
              userPermissions?.cartoes ?
                <button className={styles.btnAprove} onClick={() => navigate("/empresas-cartoes")}>
                  <HiCreditCard size={20}/>
                  <p className={styles.textAdd}>Cartões</p>
                </button>
              :""
            }
          </div>
          <div className={styles.content}>
            {
              showSearch ?
              <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}  >
                <input 
                  className={styles.searchInput}
                  ref={searchRef}
                  onChange={(e) => setNomeSearch(e.target.value)}
                  placeholder="Procurar por nome"
                  value={nomeSearch}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
                <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                  <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                  <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                </div>
              </div>
            : ""
            }
            <div className={styles.table}>
              <div className={styles.companiesColumn}>
                <p></p>
                <p>Nome</p>
                <p>NIF</p>
                <p>Ações</p>
              </div>
              <div className={styles.scrollContent}>
              {
                companiesData?.companies?.length > 0 ?
                companiesData?.companies?.map((company, index) =>
                  <div key={company.id} className={styles.companiesInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                    <div style={{display: "flex", justifyContent: "center"}}>
                      {
                        company.logo_uri ?
                        <img className={styles.foto} alt="img" src={`${Url}/image/${company.logo_uri}`} />
                        :
                        <img className={styles.noFoto} alt="img" />
                      }
                    </div>
                    <p title={company.name ? company.name : ""}>{company.name ? company.name : "-"}</p>
                    <p title={company.nif ? company.nif : ""}>{company.nif ? company.nif : "-"}</p>
                    <div className={styles.actions}>
                      <HiPencil onClick={() => navigate("/empresas/"+company.id, {state: {page: currentPage}})} className={styles.icon} size={22}/>
                      <HiTrash className={styles.icon} onClick={() => setDeleteCompany(<DeleteModal close={setDeleteCompany} objectId={company.id} objectName={company.name} deleteFunction={getAlertDelete}/>)} size={22}/>
                    </div>
                  </div>
                )
                : 
                <div className={styles.noData}>
                  <p>Não existem dados</p>
                </div>
              }
              </div>
              {
                previousPage || nextPage ?
                <div className={styles.arrows}>
                  <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => handlePageChange(true, 1)}/>
                  <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                  {currentPage ? currentPage : ""}
                  <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                  <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => handlePageChange(true, getLastPage())}/>
                </div>
                : ""
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Empresas;
